export const ADD_ASSOCIADO = "ADD_ASSOCIADO";
export const REMOVE_ASSOCIADO = "REMOVE_ASSOCIADO";
export const TOGGLE_DONE_ASSOCIADO = "TOGGLE_DONE_ASSOCIADO";
export const UPDATE_ASSOCIADO = "UPDATE_ASSOCIADO";
